/**
 * @function setcookie
 * @description set cookie based on parameters
 * @param {string} name cookie's name
 * @param {any} value cookie's value will be uri encoded. Avoid problems by passing only type string
 * @param {Date} expirationDate Date object of cookie expiration
 * @param {string} domain sites's domain
 * @param {string} path cookie's path ('/' by default)
 * @return {void}
 */
const setcookie = (name, value, expirationDate, domain, path="/") => {
    if (!name) {
        return;
    }

    if (!expirationDate) {
        expirationDate = new Date(Date.now() + 24 * 60 * 60 * 1000);
    }

    if (value) {
        value = encodeURIComponent(value);
    }

    $.ajax({
        type: "POST",
        url: $("input[name='cookieUrl']").val(),
        data: JSON.stringify({
            name: name,
            value: value,
            expirationDate: expirationDate,
            domain: domain,
            path: path
        }),
        contentType: "application/json; charset=utf-8"
    });
};

/**
 * @function getcookie
 * @description get cookie based on parameters
 * @param {string} cookieName cookie's name
 * @returns {string} cookie value of the found cookie name
 */
const getcookie = (cookieName) => {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
        let cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === " ") {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return "";
};

/**
 * @function deletecookie
 * @description delete cookie by setting expiration date to the past
 * @param name cookie's name
 */
const deletecookie = (cookieName) => {
    setcookie(cookieName, "", new Date(Date.now() - 100000));
};

export default function () {
    let cookieEnabled =  $("#cbt-site-location").data("cookie-enabled");

    if (cookieEnabled) {
        const $page = $(".page");
        let action = $page.data("action");
        let querystring = $page.data("querystring");

        if ($("#cbt-site-location").data("site-location") === "Home") {
            action = "Home-Show";
        }

        let cookieValue = action + "|" + querystring;

        $(document).ready(function () {
            setcookie("previousSiteLocation", cookieValue);
        });
    }
}

export const setCookie = setcookie;
export const getCookie = getcookie;
export const deleteCookie = deletecookie;
